import { large, regular } from './DefaultFontSize';
import presetNameList from './presetNameList';

export default {
  [presetNameList.full]: {
    tools: {
      font: {
        disabled: false,
      },
      fontSize: {
        disabled: false,
      },
      fontColor: {
        disabled: false,
      },
      bold: {
        disabled: false,
      },
      italic: {
        disabled: false,
      },
      underline: {
        disabled: false,
      },
      lineHeight: {
        disabled: false,
      },
      leftAlign: {
        disabled: false,
      },
      centerAlign: {
        disabled: false,
      },
      rightAlign: {
        disabled: false,
      },
      unorderedList: {
        disabled: false,
      },
      orderedList: {
        disabled: false,
      },
      increaseIndent: {
        disabled: false,
      },
      decreaseIndent: {
        disabled: false,
      },
      image: {
        disabled: false,
      },
      video: {
        disabled: false,
      },
      copyInlineStyle: {
        disabled: false,
      },
      clearInlineStyle: {
        disabled: false,
      },
      undo: {
        disabled: false,
      },
      redo: {
        disabled: false,
      },
      emoji: {
        disabled: false,
      },
    },
  },
  [presetNameList.light]: {
    defaultFontSize: regular,
    tools: {
      font: {
        disabled: false,
      },
      fontSize: {
        disabled: false,
        shouldCastToOneFontSize: true,
      },
      fontColor: {
        disabled: false,
      },
      bold: {
        disabled: false,
      },
      italic: {
        disabled: false,
      },
      link: {
        disabled: false,
      },
      underline: {
        disabled: false,
      },
      lineHeight: {
        disabled: true,
      },
      leftAlign: {
        disabled: true,
      },
      centerAlign: {
        disabled: true,
      },
      rightAlign: {
        disabled: true,
      },
      unorderedList: {
        disabled: true,
      },
      orderedList: {
        disabled: true,
      },
      increaseIndent: {
        disabled: true,
      },
      decreaseIndent: {
        disabled: true,
      },
      image: {
        disabled: true,
      },
      video: {
        disabled: true,
      },
      copyInlineStyle: {
        disabled: false,
      },
      clearInlineStyle: {
        disabled: false,
      },
      undo: {
        disabled: false,
      },
      redo: {
        disabled: false,
      },
      emoji: {
        disabled: false,
      },
    },
  },
  [presetNameList.header]: {
    defaultFontSize: large,
    tools: {
      font: {
        disabled: false,
      },
      fontSize: {
        disabled: false,
      },
      fontColor: {
        disabled: false,
      },
      bold: {
        disabled: false,
      },
      italic: {
        disabled: false,
      },
      underline: {
        disabled: false,
      },
      lineHeight: {
        disabled: false,
      },
      leftAlign: {
        disabled: false,
      },
      centerAlign: {
        disabled: false,
      },
      rightAlign: {
        disabled: false,
      },
      unorderedList: {
        disabled: false,
      },
      orderedList: {
        disabled: false,
      },
      increaseIndent: {
        disabled: false,
      },
      decreaseIndent: {
        disabled: false,
      },
      image: {
        disabled: true,
      },
      video: {
        disabled: true,
      },
      copyInlineStyle: {
        disabled: false,
      },
      clearInlineStyle: {
        disabled: false,
      },
      undo: {
        disabled: false,
      },
      redo: {
        disabled: false,
      },
      emoji: {
        disabled: false,
      },
    },
  },
};
